import axios from '@/modules/axios';

function loadAdsPreset() {
	return axios.get('/ads-presets');
}

function createAdsPreset(payload) {
	return axios.post('/ads-presets', payload);
}

function loadAdsPresetById() {

}

function updateAdsPreset(adsId, payload) {
	return axios.put(`/ads-presets/${adsId}`, payload);
}

function deleteAdsPreset() {

}

export {
	loadAdsPreset,
	createAdsPreset,
	loadAdsPresetById,
	updateAdsPreset,
	deleteAdsPreset,
};



// WEBPACK FOOTER //
// ./src/modules/api/AdsPreset.js